const isIos = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return isIOS;
}

const isAndroid = () => {
    const isAndroid = /Android/.test(navigator.userAgent);
    return isAndroid;
}

export {
    isIos,
    isAndroid
}